import React, { useContext, useEffect, useState } from "react";
import { PngImages, SvgImages } from "../../../Utils/LocalImages";
import { ConfirmationModalTheme, ImageFilters } from "../../../Utils/Enums";
import ButtonWithIcon from "../../../Components/Reusable/ButtonWithIcon";
import ConfirmationModal from "../../../Components/modal/ConfirmationModal";
import Image from "../../../Components/Reusable/Image";
import { Link, useNavigate, useParams } from "react-router-dom";
import RoutesPath from "../../../Utils/RoutesPath";
import * as Yup from "yup";
import { handleApiErrors, validationRegex } from "../../../Utils/Utils";
import { toast } from "react-toastify";
import generatePaginationFooter from "../../../Components/Reusable/CustomPagination";
import { AuthContext } from "../../../Context/authContext";
import BharatSatService from "../../../Services/BharatSatService";
import CustomDropDown from "../../../Components/Reusable/CustomDropDown";
import ClassService from "../../../Services/ClassService";
import DataProvider from "../../../Utils/DataProvider";
import moment from "moment";
import * as XLSX from "xlsx";

const StudentBatchList = () => {
  const { user } = useContext(AuthContext)
  const { bharatSatExamId } = useParams();
  const [data, setData] = useState([]);
  const [dataExport, setDataExport] = useState([]);
  const [searchQuery, setSearchQuery] = useState(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [deleteId, setDeleteId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);

  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const response = await BharatSatService.getStudentBatchList(
        offset,
        limit,
        searchQuery || "",
        bharatSatExamId
      );
      setData(response.data);
      setAvailableDataCount(response.availableDataCount);
      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const getStudentBatchListWithoutPagination = async () => {
    try {
      const response = await BharatSatService.getStudentBatchListWithoutPagination(bharatSatExamId);
      setDataExport(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };


  const deleteMultipleBatch = async () => {
    try {
      if (data?.findIndex((item) => item.isChecked) != -1) {
        var itemsToDelete = [];
        data.map((item) => {
          if (item.isChecked) {
            itemsToDelete.push(item.EHallTicketId);
          }
        });
      }
      await BharatSatService.deleteStudentBatch(itemsToDelete);
      toast.success("Student Batch Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  useEffect(() => {
    fetchData();
    getStudentBatchListWithoutPagination();

  }, [offset]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (
        searchQuery != null
      ) {
        fetchData();
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [searchQuery]);

  const formatTimeTo12Hour = (isoTime) => {
    if (!isoTime) return "";

    // Use Moment.js to parse the ISO time string and format it in 12-hour format with AM/PM
    return moment(isoTime).format('hh:mm A');
  };

  const exportToExcel = (data, fileName) => {
    if (!data || data.length === 0) {
      toast.info("No data to export");
      return;
    }

    // Create a worksheet from data
    const ws = XLSX.utils.json_to_sheet(data);

    // Define the grand total row
    // const grandTotalRow = [
    //     '', '', '', '', '', '', '', '', '', '', '', '', 'Grand Total', grandTotal
    // ];

    // // Add grand total row to the end of the sheet
    // XLSX.utils.sheet_add_aoa(ws, [grandTotalRow], { origin: -1 });

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Write the workbook to file
    XLSX.writeFile(wb, fileName);
  };
  const handleExportClick = () => {
    const name = user.name || "";
    const fileName = `${name} Student Batch Report.xlsx`;
    exportToExcel(dataExport, fileName);
  };
  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0">STUDENT BATCH</h1>
        <div className="d-flex align-items-center gap-1">
          <a className="back_login m-0 cursor-pointer" onClick={() => window.history.back()}>
            <Image src={SvgImages.back_arrow_login} className="m-0" />
            Back
          </a>
          <h4 className="fs-12 fw-500 black mb-0 mx-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">Student Batch</h4>
        </div>
      </div>
      <div className="table_container" style={{ display: "block" }}>
        <h1 className="black fs-18 fw-600 mb-0">Student Batch List  </h1>

        <div className="table_title">
          <div className="table_headings mt-2 Commonclass">
            <h1 className="black fs-18 fw-600 mb-0" >
              <div
                className="table_delete_icon"
                style={{
                  opacity:
                    data?.findIndex((item) => item.isChecked) == -1 ? 0.3 : 1,
                  pointerEvents: data?.findIndex((item) => item.isChecked) === -1 ? 'none' : 'auto',
                }}
                onClick={() => {
                  const viewBharaSatExamPreviledge = user?.setPrivileges?.find(
                    (priv) => priv.parameter === "Bharat Sat Exam"
                  );

                  if (!viewBharaSatExamPreviledge?.delete) {
                    // If the user does not have delete permission, show a toast warning
                    toast.warning("You don't have permission to delete Student Batch.");
                    return;
                  }
                  if (!(data.findIndex((item) => item.isChecked) == -1)) {
                    setIsMultipleDelete(true);
                    setShowDeleteModal(true);
                  }
                }}
              >
                <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
              </div>
            </h1>
            <div className="d-flex gap-4 align-items-center Responsivesection justify-content-end">
              <div className="position-relative ">
                <input
                  type="search"
                  className="search_box search_bar"
                  placeholder="Search exam"
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                />
                <Image
                  src={SvgImages.search}
                  style={ImageFilters.gray}
                  className="search_icon"
                  alt="Search Icon"
                  height="20px"
                />
              </div>

              <ButtonWithIcon
                text={"Export"}
                icon={PngImages.xlspic}
                onClick={handleExportClick}
              />
            </div>

          </div>

        </div>


        <div style={{ overflowX: "auto" }}>
          <table
            className="table mb-0 mt-3"
            id="dtHorizontalExample"
            cellSpacing="0"
            width="100%"
          >
            <thead>
              <tr className="table_heading">
                <th scope="col" style={{ width: "5%" }}>
                  <label className="d-flex align-items-center justify-content-center">
                    <input
                      className="cursor-pointer"
                      type="checkbox"
                      style={{ height: "16px", aspectRatio: 1 }}
                      checked={
                        data?.length > 0 &&
                        data?.findIndex((item) => !item.isChecked) == -1
                      }
                      onChange={(value) => {
                        var updatedData = data;
                        updatedData.map((element) => {
                          element.isChecked = value.target.checked;
                        });
                        setData([...updatedData]);
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Sr No.
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  E-Hall Ticket No.
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Student Name
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Email Id
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Class
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Medium
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  District
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Taluka
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Pincode
                </th>

              </tr>
            </thead>
            <tbody className="bg_light">
              {data?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <label className="d-flex align-items-center justify-content-center">
                      <input
                        className="cursor-pointer"
                        type="checkbox"
                        checked={item.isChecked || false}
                        style={{ height: "16px", aspectRatio: 1 }}
                        onChange={(value) => {
                          var updatedData = data;
                          updatedData[index].isChecked =
                            value.target.checked;
                          setData([...updatedData]);
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </td>
                  <td>{limit * offset + (index + 1)}</td>
                  <td title={item.hallTicketNumber}>{item.hallTicketNumber}</td>
                  <td>{item.firstName + " " + " " + item.middleName + " " + item.lastName}</td>
                  <td>{item.email}</td>
                  <td>{item.className}</td>
                  <td>{item.medium}</td>
                  <td>{item.district}</td>
                  <td>{item.taluka}</td>
                  <td>{item.pinCode}</td>
                  {/* <td>{formatTimeTo12Hour(item.medium)}</td>
                    <td>{formatTimeTo12Hour(item.examEndTime)}</td> */}


                </tr>
              ))}
            </tbody>
          </table>

        </div>
        {generatePaginationFooter(
          availableDataCount,
          limit,
          offset,
          setOffset
        )}


      </div>


      {/* Delete blog category Modal */}

      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={
          isMultipleDelete
            ? "Are you sure want to delete selected Student Batch?"
            : "Are you sure want to delete Student Batch?"
        }
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => {
          isMultipleDelete ? deleteMultipleBatch() : deleteSingleExam(deleteId);
        }}
        theme={ConfirmationModalTheme.error}
      />
      {/* Add Class Modal */}
    </div>
  );
};

export default StudentBatchList;
